import client from "api/config";
import { convertNum } from "helper/convert-num";

//////////////// gallary ////////////////
const galleryUrl = "/admin/galleries";
const getgalleryUrl = "/galleries";

export const getGalleryRequest = () => client.get(getgalleryUrl);

export const deleteGalleryRequest = (id) =>
  client.delete(`${galleryUrl}/${id}`);

export const addGalleryRequest = (values, onUploadProgress) => {
  let formData = new FormData();
  formData.append("alt", values.alt);
  formData.append("meta_description", values.meta_description);
  formData.append("keyword", values.keyword);
  values.image.isChanged && formData.append("image", values.image.url);

  return client.post(galleryUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};
